export default "Maybe you've used SORA or Midjourney before. These are generative AI programs that create *images* from a text prompt\n"